// removed by extract-text-webpack-plugin
module.exports = {"container":"container___3QrFn"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Shop/Home/ShopHome/components/Tabs/Components/PageList/index.modules.less
// module id = 1621
// module chunks = 367